export enum PaymentMethod {
  PAYMENT_CODE = "Payment Code",
  CREDIT_CARD = "Credit",
  CHECK_OR_MONEY_ORDER = "Check",
  REFUND = "Refund",
}
